export default {
  rolId:0,
  com_id:0,
  name:'',
  guard_name:'',
  rol_status:'',
  rols:null
}
